"use strict";

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataItem = function () {
  function DataItem() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, DataItem);

    this.data = data;
  }

  DataItem.prototype.isActive = function isActive() {
    return true;
  };

  DataItem.prototype.export = function _export() {
    return this.data;
  };

  return DataItem;
}();

exports.default = DataItem;